import { Form } from 'react-bootstrap';

const CheckBoxInput = ({
  name,
  $form,
  label,
  className,
  ...rest
}) => (
  <Form.Group>
    <Form.Check
      type="checkbox"
      label={label}
      name={name}
      className={`${className} small custom-checkbox`}
      checked={$form.value?.[name] ?? false}
      onChange={() => $form.update({ [name]: !$form.value?.[name] })}
      {...Object.fromEntries(Object.entries(rest).filter(([key]) => key !== '$form'))}
    />
  </Form.Group>
);

export default CheckBoxInput;
